import { AvvirEvent } from "type_aliases";

export type PushedToProcoreEvent = AvvirEvent<typeof PUSHED_TO_PROCORE, {
  issueType: string
}>

const pushedToProcore = (issueType: string): PushedToProcoreEvent => ({
  type: PUSHED_TO_PROCORE,
  payload: { issueType }
});

export const PUSHED_TO_PROCORE = "pushed_to_procore";

export default pushedToProcore;
